import qs from 'qs';
import { Alert } from 'src/types/alert';
import { Favorite } from 'src/types/favorite';
import { StrapiResponse } from 'src/types/http';

import { api } from '../../api/api';

export const findFavoriteByType = async ({
  article,
  operation,
  institution,
  professional,
  service,
  event,
  presentation,
}: {
  article: string;
  operation: string;
  institution: string;
  professional: string;
  service: string;
  event: string;
  presentation: string;
}) => {
  const query = qs.stringify(
    {
      filters: {
        article,
        operation: {
          hashId: operation,
        },
        institution,
        professional,
        service,
        event,
        presentation,
      },
      populate: [
        'article',
        'operation',
        'institution',
        'professional',
        'service',
        'event',
      ],
    },
    {
      encodeValuesOnly: true,
    },
  );

  const { data } = await api.get(
    `/favorite/get-favorites-with-alerts?${query}`,
  );
  return data;
};

export const findAllFavorites = async ({
  page,
  pageSize,
  sort,
}: {
  page: number;
  pageSize: number;
  sort: string[];
}) => {
  const query = qs.stringify(
    {
      filters: {
        presentation: {
          id: {
            $null: true,
          },
        },
      },
      pagination: {
        page,
        pageSize,
      },
      sort,
      populate: [
        'article',
        'operation',
        'operation.market',
        'professional',
        'institution',
        'service',
        'event',
      ],
    },
    {
      encodeValuesOnly: true,
    },
  );

  const { data } = await api.get(`/favorites?${query}`);
  return data;
};

export const getFavoritesWithAlerts = async ({
  collectionName,
  sort,
}: {
  collectionName?: string;
  sort: string[];
}) => {
  const query = qs.stringify(
    {
      filters: {
        ...(collectionName && {
          [collectionName]: {
            id: {
              $notNull: true,
            },
          },
        }),
        presentation: {
          id: {
            $null: true,
          },
        },
        deletedAt: {
          $null: true,
        },
      },
      sort,
      populate: [
        'article',
        'operation',
        'operation.market',
        'professional',
        'institution',
        'service',
        'event',
      ],
    },
    {
      encodeValuesOnly: true,
    },
  );
  const { data } = await api.get<
    StrapiResponse<{ favorite: Favorite; alerts: Alert[] }[]>
  >(`/favorite/get-favorites-with-alerts?${query}`);
  return data;
};

export const addFavorite = async (values: any) => {
  const { data } = await api.post('/favorites', values);
  return data;
};

export const updateFavorite = async (id: number, values: any) => {
  const { data } = await api.put(`/favorites/${id}`, values);
  return data;
};

export const removeFavorite = async (id: number) => {
  const { data } = await api.put(`/favorites/${id}`, {
    deletedAt: new Date(),
  });
  return data;
};

export const findFavoriteByOperationMarket = async (market: string) => {
  const query = qs.stringify(
    {
      filters: {
        operation: {
          market: {
            name: market,
          },
        },
      },
      populate: 'operation',
    },
    {
      encodeValuesOnly: true,
    },
  );

  const { data } = await api.get(`/favorites?${query}`);
  return data;
};
